import React from "react";
import Helmet from "react-helmet";
import { AboutMeetTheTeamHero, AboutMenu, AboutTeam } from "..";
import { apiPromiseHook } from "../../../../shared/flux/actions/enterHooks";
import * as WebRoutes from "@travellocal/utils/webRoutes";
import { EnterHookPromises } from "../../../state/enterHookPromises";
import { AboutProfiles } from "../components/profiles/aboutProfiles";
import { WorldwideTeam } from "../components/team/worldwideTeam";

import "./meetTheTeam.scss";

export const AboutMeetTheTeam = () => {
  return (
    <>
      <Helmet
        title="Meet the team"
        link={[
          {
            rel: "canonical",
            href: `${globalConfig.wwwBaseUrl}${WebRoutes.aboutMeetTheTeam()}`,
          },
        ]}
      />
      <div className="about-meet-the-team">
        <section id="header">
          <div className="width-wrapper">
            <div className="columns">
              <div className="column is-4-tablet is-3-desktop about-meet-the-team__menu">
                <AboutMenu overview={false} />
              </div>
              <div className="column is-8-tablet is-offset-4-tablet is-9-desktop is-offset-3-desktop">
                <AboutMeetTheTeamHero />
              </div>
            </div>
          </div>
        </section>

        <section id="profiles">
            <AboutProfiles />
        </section>

        <section id="worldwide-team">
          <WorldwideTeam />
        </section>

        <section id="work-with-us">
          <AboutTeam
            title="Come and work with us"
            content="Since our founding in 2012, TravelLocal has gone from strength to strength. What started as a conversation between Tom and Huw has grown into an exciting team of talented individuals all focusing on making it possible for travellers to have the best holidays by being put in touch with local experts."
            linkText="Our vacancies"
            linkUrl="https://careers.travellocal.com/"
          />
        </section>
      </div>
    </>
  );
};

export const meetTheTeamOnEnter = apiPromiseHook(EnterHookPromises.teamProfiles());
